'use client';

import { CurrencyDisplay } from '@flipster/features/src/misc/display';
import { useRouter } from '@flipster/i18n/routing';
import { IconButton } from '@flipster/react/design-system/icon-button';
import ChevronRightIcon from '@flipster/react/icon/generated/ChevronRightIcon';
import { hstack } from '@flipster/styled-system/patterns';
import { PusdtCurrency } from '@flipster/utils/constants/currency';

export const CurrencyHeader = ({ currency }: { currency: string }) => {
  const router = useRouter();
  return (
    <div className={hstack({ justify: 'space-between', color: 'content.default.level-5' })}>
      {currency === PusdtCurrency ? (
        <CurrencyDisplay
          currency={currency}
          icon={<CurrencyDisplay.Icon size={32} space={16} />}
          mainLabel={
            <div className={hstack()}>
              <CurrencyDisplay.Label value='fullName' />
              <IconButton
                icon={<ChevronRightIcon />}
                size='small'
                hierarchy='quaternary'
                onClick={() => router.push('/earn/details/premium-usdt')}
              />
            </div>
          }
          css={{ textStyle: 'Text/L/Strong' }}
        />
      ) : (
        <CurrencyDisplay
          currency={currency}
          icon={<CurrencyDisplay.Icon size={32} space={16} />}
          mainLabel={<CurrencyDisplay.Label value='shortName' />}
          css={{ textStyle: 'Text/L/Strong' }}
        />
      )}
    </div>
  );
};
